import type {ReactElement} from 'react';
import React from 'react';
import {FONT_SIZE_MAX, FONT_SIZE_MIN} from '@PosterWhiteboard/items/text-item/text-item.types';
import {ExponentialSliderOptions} from '@Components/exponential-slider-options/exponential-slider-options';
import {InputFieldSize} from '@Components/input-field-v2/input-field.types';
import styles from './base-font-size-option.module.scss';

interface BaseFontSizeOptionProps {
  fontSize: number;
  scale: number;
  onUpdateFontSize(fontSize: number, undoable?: boolean): void;
}

export function BaseFontSizeOption({...props}: BaseFontSizeOptionProps): ReactElement<any> {
  const onChangeHandler = (updatedValue: number): void => {
    props.onUpdateFontSize(updatedValue / props.scale, false);
  };

  const onChangeEnded = (updatedValue: number): void => {
    props.onUpdateFontSize(updatedValue / props.scale);
  };

  const getExponentialFunctionForwards = (val: number): number => {
    let percentageForSlider = 1;
    if (val <= 144) {
      percentageForSlider = 0.5594405594 * val - 0.5594405594;
      return (percentageForSlider * 998) / 100;
    }

    if (val <= 239) {
      percentageForSlider = 0.105 * val + 64.88;
      return (percentageForSlider * 998) / 100;
    }

    percentageForSlider = 0.013 * val + 87.013;
    return (percentageForSlider * 998) / 100;
  };

  const getExponentialFunctionBackwards = (val: number): number => {
    const valueInPercentage = (val * 100) / 998;
    if (valueInPercentage <= 80) {
      return (valueInPercentage + 0.5594405594) / 0.5594405594;
    }

    if (valueInPercentage <= 90) {
      return (valueInPercentage - 64.88) / 0.105;
    }

    if (valueInPercentage > 100) {
      return 999;
    }

    return (valueInPercentage - 87.013) / 0.013;
  };

  return (
    <ExponentialSliderOptions
      inputCounterClassName={styles.sliderOptions}
      id="item-font-size-option"
      label={window.i18next.t('pmwjs_size')}
      value={Math.round(props.fontSize * props.scale)}
      onChange={onChangeHandler}
      onChangeEnded={onChangeEnded}
      range={{min: FONT_SIZE_MIN, max: FONT_SIZE_MAX}}
      exponentialFunctionForward={getExponentialFunctionForwards}
      exponentialFunctionBackward={getExponentialFunctionBackwards}
      size={InputFieldSize.XSMALL}
    />
  );
}
